import {percantageItem} from "./interface";


export  const percantageFixer = (array:percantageItem[])=>{

    let totalPercantage = 0;
    for (let i = 0; i < array.length; i++) {
        array[i].percentage =  array[i].percentage < 1 ? 0: array[i].percentage;
        array[i].percentage =  array[i].percentage > 100 ? 100: array[i].percentage;
        totalPercantage += array[i].percentage;

    }
    const totalPercantageRatio = 100/totalPercantage;
    for (let i = 0; i < array.length; i++) {

        array[i].percentage  = array[i].percentage * totalPercantage;

    }
    return array;

}